export default __webpack_public_path__ + "static/media/link.561ea8b9.svg";